import type { ComponentProps } from 'react'

import { Toast } from '@base-ui/react'
import styled from 'styled-components'

const SnackbarContent = styled.div`
	align-items: center;
	display: flex;
	column-gap: 8px;
`

type Props = ComponentProps<typeof Toast.Content>

export const Content = ({ ...rest }: Props) => (
	<Toast.Content {...rest} render={(props) => <SnackbarContent {...props} />} />
)
